import { Link } from "react-router-dom";

const WORDMARK = "/branding/header_wordmark_clean.png";
const FULL_LOGO = "/branding/web_header_full_transparent_180h.png";
const ALT = "Nexora Learning & Development Centre";

/**
 * Nexora logo.
 * - header: horizontal wordmark (constrained by CSS, never stretched)
 * - footer: full logo on a white tile so it reads on dark backgrounds
 * - `imageUrl` still overrides (CMS-provided logo).
 */
export default function Logo({
  imageUrl,
  to = "/",
  variant = "header",
  className = "",
  "data-testid": testId = "nexora-logo",
}) {
  const inner =
    variant === "footer" ? (
      <span className="inline-flex rounded-2xl bg-white p-3 shadow-sm">
        <img src={imageUrl || FULL_LOGO} alt={ALT} className="h-20 sm:h-24 w-auto" />
      </span>
    ) : (
      <img
        src={imageUrl || WORDMARK}
        alt={ALT}
        className="h-10 sm:h-12 w-auto object-contain"
      />
    );

  if (!to) {
    return (
      <div className={className} data-testid={testId}>
        {inner}
      </div>
    );
  }
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid={testId}>
      {inner}
    </Link>
  );
}
